/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
function ModuleReason(module, dependency) {
	this.module = module;
	this.dependency = dependency;
}
module.exports = ModuleReason;



//////////////////
// WEBPACK FOOTER
// (webpack)/lib/ModuleReason.js
// module id = 4116
// module chunks = 0